import React from 'react';
import { getReporterLIst } from '../../../../../services/api';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import LoadingMore from '../../../../components/LoadingMore';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';

class MainBox extends React.PureComponent {
    state = {
        requestIndex: 1,
        list: [],
        count: 0,
        showLoadMore: true,
    };

    control = async () => {
        const { requestIndex, list, count } = this.state;
        const res = await getReporterLIst(requestIndex);
        const { data, code, toIndex, total } = res.data;

        if (code === 1) {
            this.setState({
                requestIndex: requestIndex + 1,
                list: [...list, ...data],
                count: count + 1,
            });

            if (toIndex >= total) {
                if (count <= 0) {
                    this.setState({ showLoadMore: false });
                }

                return 'end';
            } else {
                return 'success';
            }
        } else {
            return 'error';
        }
    };

    render() {
        const { list, showLoadMore } = this.state;

        return (
            <div className={styles.wrap}>
                <div className={styles.titleWrap}>
                    <div className={styles.titleIcon} />
                    <div className={styles.title}>记者</div>
                </div>
                <div className={styles.list}>
                    {list.map((item, index) => {
                        const { title, thumbnail, url, summary } = item;

                        return (
                            <div className={styles.item} key={index}>
                                <div className={styles.itemThumbnail}>
                                    {thumbnail ? (
                                        <img src={formatImage(thumbnail, 160, 160)} alt={title} />
                                    ) : (
                                        <div className={styles.noThumbnail} />
                                    )}
                                </div>
                                <div className={styles.itemText}>
                                    <div className={styles.itemTitle}>{title}</div>
                                    <div className={styles.itemSummary}>{summary}</div>
                                    {/* <div className={styles.itemMore}>
                                        <a href={url} target="_blank">
                                            查看详情 &gt;
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className={showLoadMore ? styles.showLoadMore : styles.hideLoadMore}>
                    <LoadingMore control={this.control} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(MainBox);
